/**
 * To add a new OpenableModal:
 *  1. Add a const and type to the individual openable modal ids and types
 *  2. Add the new const to the all openable modals const
 *  3. Add the new type to the all openable modals type
 *  4. Add the modal component to OpenableModalsWrapper
 *
 * (please try to add the new modal in alphabetical order)
 */

/*
 * Individual openable modal ids and types
 */
export const ACTIVITY_LOG_MODAL = 'activity_log_modal';
export type ActivityLogModal = 'activity_log_modal';
export const ADTECH_FX_INTEREST_MODAL = 'adtech_fx_interest_modal';
export type AdTechFXInterestModal = 'adtech_fx_interest_modal';
export const AGENT_STATUS_INFO_MODAL = 'agent_status_info_modal';
export type AgentStatusInfoModal = 'agent_status_info_modal';
export const ANALYTICS_ONBOARDING_MODAL = 'analytics_onboarding_modal';
export type AnalyticsOnboardingModal = 'analytics_onboarding_modal';
export const ATTRIBUTION_ONBOARDING_MODAL = 'attribution_onboarding_modal';
export type AttributionOnboardingModal = 'attribution_onboarding_modal';
export const BOARD_ONBOARDING_MODAL = 'board_onboarding_modal';
export type BoardOnboardingModal = 'board_onboarding_modal';
export const BROADCAST_INFO_MODAL = 'broadcast_info_modal';
export type BroadcastInfoModal = 'broadcast_info_modal';
export const CAMPAIGNS_ONBOARDING_MODAL = 'campaigns_onboarding_modal';
export type CampaignsOnboardingModal = 'campaigns_onboarding_modal';
export const CANCELLATION_OFFER_MODAL = 'cancellation_offer_modal';
export type CancellationOfferModal = 'cancellation_offer_modal';
export const CHATBOT_LEARN_MORE_MODAL = 'chatbot_learn_more_modal';
export type ChatbotLearnMoreModal = 'chatbot_learn_more_modal';
export const CHATBOT_THREADS_LEARN_MORE_MODAL = 'chatbot_threads_learn_more_modal';
export type ChatbotThreadsLearnMoreModal = 'chatbot_threads_learn_more_modal';
export const THREAD_LIST_SIDEBAR = 'thread_list_sidebar';
export type ThreadListSidebar = 'thread_list_sidebar';
export const THREAD_SIDEBAR = 'thread_sidebar';
export type ThreadSidebar = 'thread_sidebar';
export const COMPETITOR_IQ_INFO_MODAL = 'competitor_iq_info_modal';
export type CompetitorIqInfoModal = 'competitor_iq_info_modal';
export const CONNECTED_FORMS_INFO_MODAL = 'connected_forms_info_modal';
export type ConnectedFormsInfoModal = 'connected_forms_info_modal';
export const CREATE_PIPELINE_MODAL = 'create_pipeline_modal';
export type CreatePipelineModal = 'create_pipeline_modal';
export const DESIGN_PIPELINE_WIZARD = 'design_pipeline_wizard';
export type DesignPipelineWizard = 'design_pipeline_wizard';
export const DRIP_SEQUENCE_INFO_MODAL = 'drip_sequence_info_modal';
export type DripSequenceInfoModal = 'drip_sequence_info_modal';
export const EMBED_ANALYTICS_MODAL = 'embed_analytics_modal';
export type EmbedAnalyticsModal = 'embed_analytics_modal';
export const EMBED_CHAT_MODAL = 'embed_chat_modal';
export type EmbedChatModal = 'embed_chat_modal';
export const FEATURE_PROMO_MODAL = 'feature_promo_modal';
export type FeaturePromoModal = 'feature_promo_modal';
export const FORMS_INFO_MODAL = 'forms_info_modal';
export type FormsInfoModal = 'forms_info_modal';
export const FORM_SUBMISSION_MODAL = 'form_submission_modal';
export type FormSubmissionModal = 'form_submission_modal';
export const HELP_LEAD_RECAPS_MODAL = 'help_lead_recaps_modal';
export type HelpLeadRecapsModal = 'help_lead_recaps_modal';
export const IFRAME_MODAL = 'iframe_modal';
export type IframeModal = 'iframe_modal';
export const IMPORT_MODAL = 'import_modal';
export type ImportModal = 'import_modal';
export const INVITE_USERS_MODAL = 'invite_users_modal';
export type InviteUsersModal = 'invite_users_modal';
export const LANDING_PAGES_INFO_MODAL = 'landing_pages_info_modal';
export type LandingPagesInfoModal = 'landing_pages_info_modal';
export const NEWSLETTER_INFO_MODAL = 'newsletter_info_modal';
export type NewsletterInfoModal = 'newsletter_info_modal';
export const NUMERIC_CUSTOM_FIELDS_ONBOARDING_MODAL = 'numeric_custom_fields_onboarding_modal';
export type NumericCustomFieldsOnboardingModal = 'numeric_custom_fields_onboarding_modal';
export const PEEP_REDESIGN_ONBOARDING_MODAL = 'peep_redesign_onboarding_modal';
export type PeepRedesignOnboardingModal = 'peep_redesign_onboarding_modal';
export const PEANUT_SCHEDULER_MODAL = 'peanut_scheduler_modal';
export type PeanutSchedulerModal = 'peanut_scheduler_modal';
export const PIPELINES_FEATURE_GATE_MODAL = 'pipelines_feature_gate_modal';
export type PipelinesFeatureGateModal = 'pipelines_feature_gate_modal';
export const PRODUCT_UPDATE_DETAIL_MODAL = 'product_update_detail_modal';
export type ProductUpdateDetailModal = 'product_update_detail_modal';
export const QUOTES_AND_INVOICES_ONBOARDING_MODAL = 'quotes_and_invoices_onboarding_modal';
export type QuotesAndInvoicesOnboardingModal = 'quotes_and_invoices_onboarding_modal';
export const QUOTAS_V2_ONBOARDING_MODAL = 'quotas_v2_onboarding_modal';
export type QuotasV2OnboardingModal = 'quotas_v2_onboarding_modal';
export const SCHEDULER_ONBOARDING_MODAL = 'scheduler_onboarding_modal';
export type SchedulerOnboardingModal = 'scheduler_onboarding_modal';
export const SHARED_EMAIL_INBOX_LEARN_MORE_MODAL = 'shared_email_inbox_learn_more_modal';
export type SharedEmailInboxLearnMoreModal = 'shared_email_inbox_learn_more_modal';
export const SMS_SIDEBAR = 'sms_sidebar';
export type SmsSidebar = 'sms_sidebar';
export const VISITOR_IQ_ONBOARDING_MODAL = 'visitor_iq_onboarding_modal';
export type VisitorIqOnboardingModal = 'visitor_iq_onboarding_modal';
export const YOUTUBE_MODAL = 'youtube_modal';
export type YouTubeModal = 'youtube_modal';
export const ENGAGEMENT_BAR_ONBOARDING_MODAL = 'engagement_bar_onboarding_modal';
export type EngagementBarOnboardingModal = 'engagement_bar_onboarding_modal';
export const ENGAGEMENT_REPORT_ONBOARDING_MODAL = 'engagement_report_onboarding_modal';
export type EngagementReportOnboardingModal = 'engagement_report_onboarding_modal';
export const SMART_SEQUENCES_ONBOARDING_MODAL = 'smart_sequences_onboarding_modal';
export type SmartSequencesOnboardingModal = 'smart_sequences_onboarding_modal';
export const SMART_SEQUENCES_SURVEY_MODAL = 'smart_sequences_survey_modal';
export type SmartSequencesSurveyModal = 'smart_sequences_survey_modal';
export const DRIPS_TO_SMARTS_INFO_MODAL = 'drips_to_smarts_info_modal';
export type DripsToSmartsInfoModal = 'drips_to_smarts_info_modal';

/*
 * All openable modals const
 */
export const OpenableModals = {
    ACTIVITY_LOG_MODAL,
    ADTECH_FX_INTEREST_MODAL,
    AGENT_STATUS_INFO_MODAL,
    ANALYTICS_ONBOARDING_MODAL,
    ATTRIBUTION_ONBOARDING_MODAL,
    BOARD_ONBOARDING_MODAL,
    BROADCAST_INFO_MODAL,
    CAMPAIGNS_ONBOARDING_MODAL,
    CANCELLATION_OFFER_MODAL,
    CHATBOT_LEARN_MORE_MODAL,
    CHATBOT_THREADS_LEARN_MORE_MODAL,
    THREAD_LIST_SIDEBAR,
    THREAD_SIDEBAR,
    COMPETITOR_IQ_INFO_MODAL,
    CONNECTED_FORMS_INFO_MODAL,
    CREATE_PIPELINE_MODAL,
    DESIGN_PIPELINE_WIZARD,
    DRIP_SEQUENCE_INFO_MODAL,
    EMBED_ANALYTICS_MODAL,
    EMBED_CHAT_MODAL,
    FEATURE_PROMO_MODAL,
    FORMS_INFO_MODAL,
    FORM_SUBMISSION_MODAL,
    HELP_LEAD_RECAPS_MODAL,
    IFRAME_MODAL,
    IMPORT_MODAL,
    INVITE_USERS_MODAL,
    LANDING_PAGES_INFO_MODAL,
    NEWSLETTER_INFO_MODAL,
    NUMERIC_CUSTOM_FIELDS_ONBOARDING_MODAL,
    PEEP_REDESIGN_ONBOARDING_MODAL,
    PEANUT_SCHEDULER_MODAL,
    PIPELINES_FEATURE_GATE_MODAL,
    PRODUCT_UPDATE_DETAIL_MODAL,
    QUOTES_AND_INVOICES_ONBOARDING_MODAL,
    QUOTAS_V2_ONBOARDING_MODAL,
    SCHEDULER_ONBOARDING_MODAL,
    SHARED_EMAIL_INBOX_LEARN_MORE_MODAL,
    SMS_SIDEBAR,
    VISITOR_IQ_ONBOARDING_MODAL,
    YOUTUBE_MODAL,
    ENGAGEMENT_BAR_ONBOARDING_MODAL,
    ENGAGEMENT_REPORT_ONBOARDING_MODAL,
    SMART_SEQUENCES_ONBOARDING_MODAL,
    SMART_SEQUENCES_SURVEY_MODAL,
    DRIPS_TO_SMARTS_INFO_MODAL,
} as const;

/*
 * All openable modals type
 */
export type OpenableModalId =
    | ActivityLogModal
    | AdTechFXInterestModal
    | AgentStatusInfoModal
    | AnalyticsOnboardingModal
    | AttributionOnboardingModal
    | BoardOnboardingModal
    | BroadcastInfoModal
    | CampaignsOnboardingModal
    | CancellationOfferModal
    | ChatbotLearnMoreModal
    | ChatbotThreadsLearnMoreModal
    | CompetitorIqInfoModal
    | ConnectedFormsInfoModal
    | CreatePipelineModal
    | DesignPipelineWizard
    | DripSequenceInfoModal
    | EmbedAnalyticsModal
    | EmbedChatModal
    | FeaturePromoModal
    | FormsInfoModal
    | FormSubmissionModal
    | HelpLeadRecapsModal
    | IframeModal
    | ImportModal
    | InviteUsersModal
    | LandingPagesInfoModal
    | NewsletterInfoModal
    | NumericCustomFieldsOnboardingModal
    | PeepRedesignOnboardingModal
    | PeanutSchedulerModal
    | PipelinesFeatureGateModal
    | ProductUpdateDetailModal
    | QuotesAndInvoicesOnboardingModal
    | QuotasV2OnboardingModal
    | SchedulerOnboardingModal
    | SharedEmailInboxLearnMoreModal
    | SmsSidebar
    | ThreadListSidebar
    | ThreadSidebar
    | VisitorIqOnboardingModal
    | YouTubeModal
    | EngagementBarOnboardingModal
    | EngagementReportOnboardingModal
    | SmartSequencesOnboardingModal
    | SmartSequencesSurveyModal
    | DripsToSmartsInfoModal;

export type OpenableModal = {
    id: OpenableModalId;
    options?: any;
};
